<script>
export default {
  name: 'ClockPicker',
  props: {
    options: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      seeHours: true,
      hour: '7',
      minute: '00',
      meridian: 'PM',
    }
  },
  computed: {
    arrOf12 () {
      return Array(12)
    },
    formattedTime () {
      const t = this
      return `${t.hour}:${t.minute} ${t.meridian}`
    },
  },
  methods: {
    onNumSelect (num) {
      const formattedNum = this.formatNum(num)
      if (this.seeHours) {
        this.hour = formattedNum
        this.seeHours = false
      } else{
        this.minute = formattedNum
      }
    },
    onSave () {
      this.options.onSave({
        formatted: this.formattedTime,
        hours: Number(this.hour) + (this.meridian === 'PM' ? 12 : 0),
        hours12: Number(this.hour),
        minutes: Number(this.minute),
        meridian: this.meridian,
      })
    },
    onClear () {
      this.options.onSave('')
    },
    formatNum (num) {
      if (this.seeHours) {
        return num + 1
      } else {
        const init = (num + 1) % 12 * 5
        return init < 10 ? '0' + init : init
      }
    },
    getNumStyle (num) {
      num = num - 2 // rotate numbers back 2 spots cuz math
      const toDegrees = (val) => val * 30
      const toRad = (val) => toDegrees(val) * Math.PI / 180
      return {
        transform: 'translateX(' + Math.cos(toRad(num)) * 100 + 'px) translateY(' + Math.sin(toRad(num)) * 100 + 'px)'
      }
    }
  },
}
</script>

<template lang="pug">
  .clock-picker.modal-main
    .clock-picker-container.modal-container(
      :class='seeHours ? "see-hours" : ""'
    )
      .display
        .hour(
          @click='seeHours = true'
        ) {{hour}}
        .colon :
        .minute(
          @click='seeHours = false'
        ) {{minute}} 
        .meridian-holder(
          @click='meridian = meridian === "AM" ? "PM" : "AM"'
        )
          .big {{meridian}}
          .little {{meridian === "AM" ? "PM" : "AM"}}
      .number-holder
        .number(
          v-for='(_, num) in arrOf12'
          :style='getNumStyle(num)'
          @click='onNumSelect(num)'
        ) {{formatNum(num)}}
        .center-dot
      .buttons
        .button.clear(
          @click='onClear'
        ) CLEAR
        .button.save(
          @click='onSave'
        ) DONE
</template>

<style lang="sass" scoped>
  .clock-picker
    .clock-picker-container
      &.see-hours
        .display
          .hour
            opacity: 1
          .minute
            opacity: .4
      .display
        margin: 0 auto 25px
        width: fit-content
        user-select: none
        > *
          display: inline-block
          font-size: 2em
          font-weight: 600
          cursor: pointer
        .hour
          opacity: .4
        .meridian-holder
          margin-left: 5px
          > *
            display: inline
            transition: all .25s
          .big
          .little
            font-size: .5em
            opacity: .4
      .number-holder
        height: 250px
        width: 210px
        position: relative
        margin: 0 auto
        transform: translateX(-25px) translateY(-25px)
        .center-dot
          position: absolute
          top: calc(50% + 25px)
          left: calc(50% + 25px)
          transform: translateX(-50%) translateY(-50%)
          width: 10px
          height: 10px
          border-radius: 5px
          background-color: black
        .number
          position: absolute
          top: 50%
          left: 50%
          cursor: pointer
          user-select: none
          transition: all .25s
          height: 50px
          width: 50px
          background-color: transparent
          text-align: center
          line-height: 50px
          border-radius: 25px
          font-size: 1.2em
          &:hover
            font-weight: 600
            background-color: lightgrey
            color: white
      .buttons
        display: grid
        grid-template-columns: 50% 50%
        width: fit-content
        margin: 0 auto
        .button
          margin: 10px 15px 0
          width: fit-content
          background-color: black
          padding: 10px 25px
          font-weight: 700
          border-radius: 5px
          color: white
          cursor: pointer
          transition: all .25s
          &:hover
            box-shadow: 0 0 5px 0 grey
          &.clear
            background-color: transparent
            border: grey thin solid
            color: black
</style>
